import './App.css';
import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from "./components/navbar.jsx";
import Intro from "./components/intro.jsx";
import Test from "./components/test.jsx";
import Quiz from "./components/quiz.jsx";
import Admin from "./admin/admin.jsx";

function App() {

  const [ scrollProgress, setScrollProgress ] = useState(0);

  useEffect(() => {

    const handleScroll = () =>  {

      const scrollTop = window.scrollY;

      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      const maxScroll = scrollHeight - clientHeight;

      const progress =
        maxScroll > 0 ? (scrollTop / maxScroll) * 100 : 0;

      setScrollProgress(progress);

    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };

  }, []);

  return (
    <Router>
      <div className="App">

        <Navbar scrollProgress={scrollProgress} />

        <Routes>
          
          <Route path="/" element={<Intro scrollProgress={scrollProgress} />} />

          <Route path="/quiz/*" element={<Quiz />} />

          <Route path="/admin/*" element={<Admin />} />

          <Route path="/uebungen/*" element={<Test />} />

        </Routes>

      </div>
    </Router>
  );
}

export default App;
